module.exports = __webpack_public_path__ + "img/ce21983.png";